module.exports = __webpack_public_path__ + "img/icon-success.f3604336.png";